/**
 * @fileoverview Enumeration defining the types of override fields.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 *
 */

/** @enum {string} */
export const OverrideFieldType = {
  NONE: 'NONE',
  CUSTOM: 'CUSTOM',
  BUILTIN: 'BUILTIN',
};
